module.exports = {
      id: "mail-usage",
      viewBox: "0 0 19 14.3",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#mail-usage",
      toString: function () {
        return this.url;
      }
    }